import { useNavigate, useParams } from "react-router-dom";
import ContainerComponent from "../../../components/conatiner";
import HeaderComponent from "../../../components/header";
import CardComponent from "../../../components/card";
import InputComponent from "../../../components/input";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { ManagersEmployeesPasswordService, ManagersEmployeesShowService, ManagersEmployeesUpdateService } from "../../../services/managers/employees";
import { ToastErro, ToastSucesso } from "../../../components/toast";
import LoadingComponent from "../../../components/loading";

const ManagersEmployeesUpdatePage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const { id } = useParams();

    const [user, setUser] = useState<any>(null!);

    // variaveis editar
    const [cpf, setCpf] = useState<string>('');
    const [bank, setBank] = useState<string>('');
    const [agency, setAgency] = useState<string>('');
    const [account, setAccount] = useState<string>('');
    // variaveis editar

    // variaveis alterar senha
    const [password, setPassword] = useState<string>('');
    const [confPassword, setConfPassword] = useState<string>('');
    // variaveis alterar senha

    // função para pesquisar informações do usuário
    const getUser = async () => {

        setLoading(true);

        await ManagersEmployeesShowService(parseInt(id!)).then(resp => {
            setUser(resp.data);
            setCpf(resp.data.cpf);
            setBank(resp.data.bank);
            setAgency(resp.data.agency);
            setAccount(resp.data.account);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            navigate('/managers/employees');
        });

        setLoading(false);

    }
    // função para pesquisar informações do usuário

    // função para atualizar dados do usuário
    const updateUser = async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        setLoading(true);

        await ManagersEmployeesUpdateService(parseInt(id!), cpf, bank, agency, account).then(resp => {
            ToastSucesso(resp.data.message);
            navigate('/managers/employees');
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para atualizar dados do usuário

    // função para alterar a senha do usuário
    const changePassword = async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        if (password.length < 6) {
            ToastErro('A senha deve conter no mínimo 6 caracteres!');
            return;
        }

        if (password != confPassword) {
            ToastErro('As senhas não são iguais!');
            return;
        }

        setLoading(true);

        await ManagersEmployeesPasswordService(parseInt(id!), password).then(resp => {
            ToastSucesso(resp.data.message);
            navigate('/managers/employees');
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para alterar a senha do usuário

    useEffect(() => {
        getUser();
    }, []);

    return (
        <>
            <HeaderComponent
                title="Editar Funcionário"
                button="Voltar"
                iconButton="arrow_back"
                onClick={() => navigate('/managers/employees')}
            />
            <ContainerComponent>
                <>
                    <div className="row">
                        <CardComponent
                            col={8}
                        >
                            {
                                loading

                                    ?

                                    <LoadingComponent />

                                    :

                                    <form onSubmit={updateUser}>
                                        <div className="card-title mb-4">
                                            Informações do Usuário
                                        </div>
                                        <div className="row">
                                            <InputComponent
                                                label="Nome"
                                                col={12}
                                                defaultValue={user?.name}
                                                disabled
                                            />
                                        </div>
                                        <div className="row">
                                            <InputComponent
                                                label="Username"
                                                col={6}
                                                defaultValue={user?.username}
                                                disabled
                                            />
                                            <InputComponent
                                                label="E-mail"
                                                col={6}
                                                defaultValue={user?.email}
                                                disabled
                                            />
                                        </div>
                                        <div className="row">
                                            <InputComponent
                                                label="CPF"
                                                col={3}
                                                defaultValue={cpf}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setCpf(e.target.value)}
                                                required
                                            />
                                            <InputComponent
                                                label="Banco"
                                                col={3}
                                                defaultValue={bank}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setBank(e.target.value)}
                                                required
                                            />
                                            <InputComponent
                                                label="Agência"
                                                col={3}
                                                defaultValue={agency}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setAgency(e.target.value)}
                                                required
                                            />
                                            <InputComponent
                                                label="Conta"
                                                col={3}
                                                defaultValue={account}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setAccount(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end mt-4">
                                            <button className="btn btn-primary" type="submit">Salvar</button>
                                        </div>
                                    </form>
                            }
                        </CardComponent>
                        <CardComponent
                            col={4}
                        >
                            <form onSubmit={changePassword}>
                                <div className="card-title mb-4">
                                    Alterar Senha
                                </div>
                                {
                                    loading

                                        ?

                                        <LoadingComponent />

                                        :

                                        <>
                                            <div className="row">
                                                <InputComponent
                                                    label="Senha"
                                                    col={12}
                                                    defaultValue={password}
                                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                                                    required
                                                    type={'password'}
                                                />
                                            </div>
                                            <div className="row">
                                                <InputComponent
                                                    label="Confirme a Senha"
                                                    col={12}
                                                    defaultValue={confPassword}
                                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setConfPassword(e.target.value)}
                                                    required
                                                    type={'password'}
                                                />
                                            </div>
                                            <div className="d-flex justify-content-end mt-4">
                                                <button className="btn btn-primary" type="submit">Alterar Senha</button>
                                            </div>
                                        </>
                                }
                            </form>
                        </CardComponent>
                    </div>
                </>
            </ContainerComponent>
        </>
    );

}

export default ManagersEmployeesUpdatePage;